import CancellationPolicyCard from 'component/page/detail/CancellationPolicyCard/CancellationPolicyCard';
import React from 'react';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesCancellationContainerSeenEventActivitiesFieldsV3 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesCancellationContainerSeenEventActivitiesManifestV3 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import { useInView } from 'react-intersection-observer';

export const CancellationPolicyModular: React.FC = () => {
    const onSeen = (inView: boolean) => {
        if (inView) {
            trackElementEvent<ActivitiesCancellationContainerSeenEventActivitiesFieldsV3>(ActivitiesCancellationContainerSeenEventActivitiesManifestV3.ids, {
                is_toggle_on: true,
            });
        }
    };

    const { ref: cancellationPolicyRef } = useInView({ triggerOnce: false, threshold: 1, onChange: onSeen });

    return (
        <div ref={cancellationPolicyRef}>
            <CancellationPolicyCard />
        </div>
    );
};
CancellationPolicyModular.displayName = 'CancellationPolicyModular';
